 class MoObjectUtils {
     isEmpty(obj) {
        for (var x in obj) {
            if (obj.hasOwnProperty(x))
                return false;
        }
        return true;
    }
}
const _default = new MoObjectUtils();
export { _default as default };

//# sourceMappingURL=MOObjectUtils.js.map